declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

const PIXEL_ID = '1086059581265994'

// Skip pixel inside sandboxed previews (Magic Patterns iframe, localhost, etc.)
// to avoid cross-origin "Script error." from third-party fbevents.js.
function shouldSkipPixel(): boolean {
  if (typeof window === 'undefined') return true
  try {
    const host = window.location.hostname
    const inIframe = window.self !== window.top
    const isPreviewHost =
      host.includes('magicpatterns') ||
      host === 'localhost' ||
      host.startsWith('127.') ||
      host.endsWith('.local')
    return inIframe || isPreviewHost
  } catch {
    // Cross-origin access on window.top throws — assume we're in a preview iframe.
    return true
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return
  if (shouldSkipPixel()) {
    // eslint-disable-next-line no-console
    console.info('[MetaPixel] skipped (preview/iframe environment)')
    return
  }

  try {
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments as any)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      // Swallow any load errors from the third-party script so they don't
      // surface as a generic cross-origin "Script error.".
      t.onerror = () => {
        // eslint-disable-next-line no-console
        console.warn('[MetaPixel] fbevents.js failed to load')
      }
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
    // eslint-disable-next-line no-console
    console.info('[MetaPixel] init + PageView →', PIXEL_ID)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] init failed', err)
  }
}

export function trackAddToCart() {
  if (typeof window === 'undefined') return
  const payload = {
    content_name: 'Metabolismo Silver 21',
    content_ids: ['metabolismo-silver-21'],
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  }
  try {
    window.fbq?.('track', 'AddToCart', payload)
    // eslint-disable-next-line no-console
    console.info('[MetaPixel] AddToCart →', payload)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] AddToCart failed', err)
  }
}
